import { clsx } from 'clsx';

const variants = {
  primary: 'bg-primary-subtle text-primary',
  success: 'bg-success-bg text-success-text',
  warning: 'bg-warning-bg text-warning-text',
  danger: 'bg-danger-bg text-danger-text',
  info: 'bg-info-bg text-info-text',
  accent: 'bg-accent-subtle text-accent',
  neutral: 'bg-bg-secondary text-text-secondary border border-border',
};

function Badge({ variant = 'neutral', className, children, ...props }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
